import Swal from "sweetalert2";
import { unlockGlobalAudio, playGlobalAudio } from "./audioManager";

let offlinePlayed = false;
let initialized = false;

export function initOfflineListener() {
    if (initialized) return;
    initialized = true;

    // 🔑 Unlock audio on first user interaction
    window.addEventListener("click", unlockGlobalAudio, { once: true });
    window.addEventListener("keydown", unlockGlobalAudio, { once: true });

    function updateOnlineStatus() {
        if (!navigator.onLine) {
            if (!offlinePlayed) {
                playGlobalAudio();
                offlinePlayed = true;
            }

            Swal.fire({
                title: "There is a problem with your internet connection.",
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading();
                },
                onClose: () => {
                },
            });
        } else {
            offlinePlayed = false;
            window.location.reload();
        }
    }

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
}